import React from 'react';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import './ScorecardChooser.styl';
import NavActions from 'actions/NavActions';
import {overrideName} from 'components/nav/renderers/ScorecardChooserOverrideNav';

export default class ScorecardChooser extends React.PureComponent {
  static defaultProps = {
    topNav: overrideName,
  };

  componentDidMount() {
    NavActions.setNavOverride.defer(this.props.topNav, {
      goBack: this.props.goBack,
    });
  }

  componentWillUnmount() {
    NavActions.clearNavOverride.defer();
  }

  render() {
    const {scorecards, suppressUnscored, newCallCard} = this.props;

    if (newCallCard) {
      const scoreLabel = scoreCount => {
        if (!scoreCount) return 'no scores';
        if (scoreCount === 1) return '1 score';
        return `${scoreCount} scores`;
      };
      return (
        <div className="new-call-card scorecard-chooser">
          <p className="header">Select a card to begin scoring</p>
          <div className="tab-scorecard-list">
            {scorecards?.map(s => (
              <div
                key={s.id}
                className="scorecard-item"
                onClick={() => this.props.onChooseScorecard(s)}>
                <span className="name">{s.name}</span>
                <span className="scores">{scoreLabel(s.results.size)}</span>
              </div>
            ))}
          </div>
          {this.props.children && <div className="child-container">{this.props.children}</div>}
        </div>
      );
    }

    return (
      <div className="scorecard-chooser">
        <h3>Scorecards</h3>
        <p>
          The following scorecards are relevant to this call. Click on each scorecard to answer and
          view results.
        </p>
        <div className="button-group">
          {scorecards &&
            scorecards.map(scorecard => {
              const hasResults = scorecard.results.count() > 0;

              if (!hasResults && suppressUnscored) return null;

              return (
                <div
                  key={scorecard.id}
                  className="double-column-button"
                  onClick={() => this.props.onChooseScorecard(scorecard)}>
                  <span>{scorecard.name}</span>
                  {hasResults && <CheckIcon className="icon check" />}
                </div>
              );
            })}
        </div>
        {this.props.children && <div className="child-container">{this.props.children}</div>}
      </div>
    );
  }
}
